export default __webpack_public_path__ + "static/media/AppoinmentIcon.55566820.svg";